import React, { useEffect,useMemo,useState } from 'react'
import { useCurrent, useDelete, useFetch } from '../../hooks'
import {CardHeaderWithActions, MwButton} from '../../components/ui'
import AddNewRatingService from './AddNewRatingService'
import RatingServicesList from './RatingServicesList'
import { useTranslation } from 'react-i18next'

const RatingServicesManager = () => {
    const [t] = useTranslation('global')
    const [mode,setMode] = useState('Listing');
    const {currentTenantId,currentBranchId,currentCompanyId} = useCurrent();
    const servicesUrl = useMemo(() => {
        if (!currentTenantId || !currentCompanyId || !currentBranchId) return null;
        return `${process.env.REACT_APP_RATING_API_BASE_URL}/services/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
    }, [currentTenantId, currentCompanyId, currentBranchId]);
    const {data:servicesResult,loading:servicesLoading,refreshHandler} = useFetch(servicesUrl, Boolean(servicesUrl));
    const {data:deleteResult,loading:deleteLoading,deleteItem} = useDelete();
    const [showConfirmDelete,setShowConfirmDelete] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState('');

    const addNewHandler = () => {
        setMode('Adding');
    }
    const ListingHandler = () => {
        setMode('Listing');
    }
    const onSubmitCallBack = () =>{
        ListingHandler();
        refreshHandler();
    }

    const deleteHandler = (id) => {
        const _deleteUrl = `${process.env.REACT_APP_RATING_API_BASE_URL}/services/${id}`;
        deleteItem(_deleteUrl);
    }

    useEffect(()=>{
        if(servicesResult){
            const services = Array.isArray(servicesResult?.data) ? servicesResult.data : [];
            if(services.length === 0){
                setMode('Adding')
            }
            console.log('servicesResult => ',servicesResult);
        }
    },[servicesResult]);

    useEffect(()=>{
        if(deleteResult){
            setShowConfirmDelete(false);
            setSelectedDeleteId('');
            refreshHandler();
        }
    },[deleteResult]);


    return (
        <div className='h-full flex flex-col '>
            <CardHeaderWithActions title={t('services.managerTitle')}>
                {mode !== 'Adding' && <MwButton onClick={addNewHandler} type='saveBtn'>{t('services.addNew')}</MwButton> }
                {mode === 'Adding' && <MwButton onClick={ListingHandler} type='secondary'>{t('services.manage')}</MwButton> }
            </CardHeaderWithActions>
            <div className='h-full '>
                {mode ==='Adding' && <AddNewRatingService onSubmitCallBack={onSubmitCallBack}/>}
                {mode ==='Listing' && <RatingServicesList 
                                        showConfirmDelete ={showConfirmDelete}
                                        setShowConfirmDelete ={setShowConfirmDelete}
                                        selectedDeleteId={selectedDeleteId}
                                        setSelectedDeleteId={setSelectedDeleteId}
                                        deleteLoading={deleteLoading} 
                                        deleteHandler={deleteHandler} 
                                        addNewHandler={addNewHandler}
                                        data={servicesResult} 
                                        loading={servicesLoading} 
                                        />}
            </div>
        </div>
    )
}

export default RatingServicesManager
